export const cleanUpMoneyEntry = value => {
  return typeof value === 'string' ? value.replace(/[^\d.-]/g, '') : value;
};

export const cleanUpMoneyEntryToFloat = value => {
  if (!value) return 0;
  return parseFloat(cleanUpMoneyEntry(value));
};
